import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Link,
  Alert,
  AlertTitle,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material"; // Import icons
import people from "../LoginOrg/Images/people.png";
import yellow from "../LoginOrg/Images/yellow.png";
import { ORG_REGISTER } from "../../api/orgAuth";
import axios from "axios";
import { useHistory } from "react-router-dom";

const SignupOrg = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [orgName, setOrgName] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Toggle confirm password visibility
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useHistory();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (token || role) {
      if (role === "user") {
        navigate.push("/dashboard/" + localStorage.getItem("id"));
      } else if (role === "org") {
        navigate.push("/orgdashboard/" + localStorage.getItem("id"));
      } else if (role === "student") {
        navigate.push("/studentdashboard/" + localStorage.getItem("id"));
      }
    }
  }, [navigate]);

  const handleSignup = () => {
    setErrorMessage("");
    setSuccessMessage("");

    if (!email || !password || !confirmPassword || !orgName) {
      setErrorMessage("Please fill in all fields");
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }

    const signupData = { email, password, orgName };

    axios
      .post(ORG_REGISTER, signupData)
      .then(() => {
        setSuccessMessage("Signup successful!");
        navigate.push("/loginorg");
      })
      .catch((error) => {
        if (error.response) {
          setErrorMessage("Signup failed: " + error.response.data.message);
        } else {
          setErrorMessage("An error occurred during signup");
        }
      });
  };

  return (
    <Box
      sx={{
        marginTop: "0px",
        backgroundColor: "#fff",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        padding: "60px",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
          px: 2,
          py: { xs: 4, md: 8 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column-reverse", md: "row" },
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            maxWidth: "1200px",
            gap: { xs: 6, md: 12 },
          }}
        >
          {/* Image Section */}
          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={people}
              alt="People Illustration"
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: 400,
                height: "auto",
              }}
            />
          </Box>

          {/* Signup Form Section */}
          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: "#000",
                mb: 2,
                textAlign: "center",
                fontWeight: 600,
              }}
            >
              Corporate {"<>"} College Collaboration Portal
            </Typography>

            <Box
              sx={{
                width: "100%",
                maxWidth: 400,
                p: 4,
                borderRadius: 3,
                backgroundColor: "#6a58c6",
                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{ color: "#fff", textAlign: "center", fontWeight: 500 }}
              >
                Signup
              </Typography>

              {errorMessage && (
                <Alert severity="error" sx={{ width: "100%" }}>
                  <AlertTitle>Error</AlertTitle>
                  {errorMessage}
                </Alert>
              )}
              {successMessage && (
                <Alert severity="success" sx={{ width: "100%" }}>
                  <AlertTitle>Success</AlertTitle>
                  {successMessage}
                </Alert>
              )}

              {/* Fields */}
              {[
                ["Email ID", email, setEmail],
                ["Organization Name", orgName, setOrgName],
              ].map(([label, value, setter], i) => (
                <TextField
                  key={i}
                  label={label}
                  variant="outlined"
                  fullWidth
                  value={value}
                  onChange={(e) => setter(e.target.value)}
                  InputProps={{
                    sx: {
                      backgroundColor: "white",
                      borderRadius: "6px",
                    },
                  }}
                />
              ))}

              <TextField
                label="Password"
                variant="outlined"
                type={showPassword ? "text" : "password"}
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  sx: { backgroundColor: "white", borderRadius: "6px" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                label="Confirm Password"
                variant="outlined"
                type={showConfirmPassword ? "text" : "password"}
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                InputProps={{
                  sx: { backgroundColor: "white", borderRadius: "6px" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                variant="contained"
                onClick={handleSignup}
                sx={{
                  background: "#000",
                  color: "#fff",
                  fontWeight: 600,
                  mt: 1,
                  py: 1.2,
                  "&:hover": {
                    background: "#333",
                  },
                }}
              >
                Signup
              </Button>

              <Typography sx={{ color: "#fff", mt: 1, fontSize: "14px" }}>
                Already have an account?{" "}
                <Link
                  href="/loginorg"
                  sx={{ color: "#FFD700", fontWeight: 500 }}
                >
                  Sign in
                </Link>
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Background Banner */}
        {/* <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "80px",
            backgroundImage: `url(${yellow})`,
            backgroundRepeat: "repeat-x",
            backgroundSize: "contain",
            display: { xs: "none", md: "flex" },
          }}
        /> */}
      </Box>
    </Box>
  );
};

export default SignupOrg;
